import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { fullBrandName } from 'utils/environment';

import { GeolocationPermissionModalView } from '../geolocation-permission-modal.view';
import { IGeolocationPermissionModalProps } from '../types';

const FULL_BRAND_NAME = fullBrandName();
/**
 *
 * GeolocationGrantedModal contains logic required to render UI
 *  view is split from this component to enable separate logic
 *  between web and app -> specifically, logic around opening
 *  native settings. also some copy differences
 *
 */
export const GeolocationGrantedModal: FC<IGeolocationPermissionModalProps> = ({
  isOpen,
  dismissModal,
}) => {
  const { formatMessage } = useIntl();
  return (
    <GeolocationPermissionModalView
      flowTestId="granted"
      isOpen={isOpen}
      dismissModal={dismissModal}
      modalBodyText={formatMessage(
        { id: 'disableBrowserLocationSettings' },
        { brand: FULL_BRAND_NAME }
      )}
      modalHeadingText={formatMessage({ id: 'disableLocationServices' })}
      openSettingsButtonText={formatMessage({ id: 'browserSettings' })}
    />
  );
};

export default GeolocationGrantedModal;
